import React, { useRef, useEffect, useState } from "react";
import { LanguageService } from "../../../services/LanguageService";

const AnnouncementPopup = ({ closePopup, announcementText }) => {
  // const handleCloseModal = () => {
  //   props.onClosePopup();
  // };
  return (
    <div className="tb--modal-lvl1">
      <div className="tb--modal-lvl2">
        <div className="tb--modal-lvl3 tb--announcement-popup_wrapper tb--rel">
          <div className="tb--modal-popup tb--announcement-popup tb--flex tb--flex-col">
            <div className="tb--modal-header tb--flex tb--align-center tb--justify-end tb--pr-12">
              <span className="tb--modal-header-txt tb--flex-grow tb--ellipsis tb--text_upercase">
                {LanguageService.getTranslation('details')}
              </span>
              <div className="tb--modal-close" onClick={closePopup}>
                <i className="digi_icon-close"></i>
              </div>
            </div>
            <div className="tb--body-panel">
              <div className="tb--modal-body tb--flex-grow">
                <div className="tb-announcement-more-text"  dangerouslySetInnerHTML = {{ __html: decodeURIComponent(atob(announcementText))}} ></div>
              </div>
              <div>
                <button type="button" className="btn btn__main-clr tb--btn tb--nowrap tb--ellipsis tb--mt-40 tb--mb-40" onClick={closePopup}>{LanguageService.getTranslation('okButton')}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
